import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { Divider } from '../../styles';
import { CustomerInformation } from '../../interfaces/Cart';
import TMarkUp from '../TMarkUp';

const DetailsSection = styled.div`
  padding: 1.5rem 0;

  h3 {
    margin-bottom: 1.25rem;
  }
`;

/* global CSS_CONFIG */
const DetailsAlFuttaim: React.FC<CustomerInformation> = ({
  firstName,
  lastName,
  addressFieldInfo,
  city,
  state,
  district,
  email,
  phoneNumber,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <DetailsSection>
        <h3 className="h4">
          <TMarkUp value={t('spareParts.summary.delivery.title')} />
        </h3>
        <div
          aria-label={`Name: ${firstName} ${lastName}`}
        >{`${firstName} ${lastName}`}</div>
        <div aria-label={`Address: ${addressFieldInfo}`}>
          {addressFieldInfo}
        </div>
        <div>{`${city}`}</div>
        {district && <div>{`${district}`}</div>}
        {state && <div>{`${state}`}</div>}
      </DetailsSection>
      <Divider />
      <DetailsSection>
        <h3 className="h4">
          <TMarkUp
            value={t('spareParts.summary.delivery.contactInformation')}
          />
        </h3>
        <div aria-label={`Email: ${email}`}>{email}</div>
        <div aria-label={`Phone Number: ${phoneNumber}`}>{phoneNumber}</div>
      </DetailsSection>
    </>
  );
};
export default DetailsAlFuttaim;
